import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { timestamp } from "~/utils/datetime"

export const useCurrentDefenderAdHocStore = defineStore(
  "currentDefenderAdHoc",
  () => {
    // State
    const confirmed: Ref<boolean> = ref(false)
    const profile: Ref<any> = ref({})

    // Actions
    function confirmAdHocProfile(payload: { profile: any }) {
      profile.value = {
        ...payload.profile,
        updated: timestamp(),
      }
      confirmed.value = true
    }

    function resetCurrentDefenderAdHoc() {
      profile.value = {}
      confirmed.value = false
    }

    function setCurrentDefenderAdHoc(payload: any) {
      profile.value = payload
      confirmed.value = true
    }

    return {
      // State
      confirmed,
      profile,
      // Actions
      confirmAdHocProfile,
      resetCurrentDefenderAdHoc,
      setCurrentDefenderAdHoc,
    }
  },
  {
    persist: {
      key: "unitcrunch-defender-adhoc",
    },
  }
)
